<template>
    <div class="mx-sm-1 mt-9">
      <div class="page-header">
          <h1 class="page-title fw-bold">Les Gouvernances</h1>
          <div>
              <ol class="breadcrumb">
                  <li class="breadcrumb-item"><router-link :to="{ name: 'dashboard' }"><a>Tableau de bord</a></router-link></li>
                  <li class="breadcrumb-item active" aria-current="page"><router-link :to="{ name: 'gouvernance' }"><a>Les Gouvernances</a></router-link></li>
              </ol>
          </div>
      </div>
      <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-12" v-if="showList">
              <div class="card">
                  <div class="card-header">
                      <h3 class="card-title fw-bold">Liste des gouvernances</h3>
                      <div class="card-options">
                        <SearchInputAll></SearchInputAll>
                        <button class="btn btn-info mx-2" @click="showForm"><span class="fe fe-plus"></span> Nouvelle gouvernance</button>
                        <button class="btn btn-outline-primary mx-2" @click="showTypesGouvernance"><span class="fe fe-tag"></span> Les types de gouvernance</button>
                    </div>
                  </div>
                  <div class="card-body pt-4">
                      <div class="grid-margin">
                          <div class="panel panel-primary">
                              <div class="panel-body tabs-menu-body border-0 pt-0">
                                  <div class="tab-content">
                                      <div class="tab-pane active" id="tab5">
                                          <div class="table-responsive">
                                              <table id="data-table" class="table table-responsive table-hover table-bordered text-nowrap mb-0">
                                                  <thead class="border-top success02">
                                                      <tr>
                                                          <th class="bg-transparent border-bottom-0 fw-bold">
                                                              Id Gouvernance
                                                          </th>
                                                          <th class="bg-transparent border-bottom-0 fw-bold">
                                                              Titre
                                                          </th>
                                                          <th class="bg-transparent border-bottom-0 fw-bold">
                                                              Statut Gouvernance
                                                          </th>
                                                          <th class="bg-transparent border-bottom-0 fw-bold">
                                                              Type de Gouvernance
                                                          </th>
                                                          <th class="bg-transparent border-bottom-0 fw-bold">
                                                              Président
                                                          </th>
                                                          <th class="bg-transparent border-bottom-0 fw-bold">
                                                              Rapporteur
                                                          </th>
                                                          <th class="bg-transparent border-bottom-0 fw-bold">
                                                              PMO Référent
                                                          </th>
                                                          <th class="bg-transparent border-bottom-0 fw-bold">
                                                              Point Focal (Chef Projet)
                                                          </th>
                                                          <th class="bg-transparent border-bottom-0 fw-bold"
                                                              style="width: 5%;">Actions</th>
                                                      </tr>
                                                  </thead>
                                                  <tbody v-if="filterItems[0]" id="myTable1">
                                                      <tr v-for="(item, index) in filterItems" :key="index" class="border-bottom">
                                                          <td class="text-center">{{ item?.idGouvernance }}</td>
                                                          <td>{{ item?.titre }}</td>
                                                          <td class="text-center">
                                                            <div class="mt-0 mt-sm-3 d-block">
                                                                <span class="p-2 px-3 alert" :style="'background-color: '  + statusEtat(item?.statutGouvernance)">{{ item?.statutGouvernance }}</span>
                                                            </div>
                                                          </td>
                                                          <td>{{ item?.idTypeGouvernance?.nomTypeGouvernance }}</td>
                                                          <td>{{ item?.president?.contact }}</td>
                                                          <td>{{ item?.rapporteur?.contact }}</td>
                                                          <td>{{ item?.pmoReferent?.contact }}</td>
                                                          <td>{{ item?.pointFocalAsin?.contact }}</td>
                                                          <td>
                                                              <div class="g-2">
                                                                  <button class="btn text-primary btn-sm" @click="edit(item)"
                                                                      data-bs-toggle="tooltip"
                                                                      data-bs-original-title="Modifier"><span
                                                                          class="fe fe-edit fs-18"></span></button>
                                                                  <button class="btn text-danger btn-sm" @click="drop(item)"
                                                                      data-bs-toggle="tooltip"
                                                                      data-bs-original-title="Supprimer"><span
                                                                          class="fe fe-trash-2 fs-18"></span></button>
                                                              </div>
                                                          </td>
                                                      </tr>
                                                  </tbody>
                                                  <tbody v-else>
                                                      <tr class="primary02">
                                                          <td colspan="10" class="text-center">Aucune gouvernance trouvée</td>
                                                      </tr>
                                                  </tbody>
                                              </table>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              
          </div>
          <!-- COL END -->
           <div class="row" v-else>
              <div class="col-sm-12 col-md-12">
                  <div class="card">
                      <div class="card-header">
                          <h3 class="card-title fw-bold">{{ save ? 'Création d\'une Gouvernance' : 'Modification d\'une gouvernance'}}</h3>
                      </div>
                      <div class="card-body">
                          <ValidationObserver v-slot="{ handleSubmit }">
                              <form @submit.prevent="handleSubmit(onNextep)">
                                <div class="row mb-2 mx-auto d-flex style_niveau">
                                    <div :class="['col mb-3 px-sm-0 px-1', index < (steps.length - 1) ? 'col-sm' : 'col-sm-auto']"
                                        v-for="(step, index) in steps" :key="'step' + index">
                                        <div :class="['d-flex align-items-center', { 'active': payload.currentStep > index + 1 }]">
                                        <div
                                            class="border border d-flex justify-content-center align-items-center bg-light style_same_height_width_60"
                                            @click.prevent="payload.currentStep = payload.currentStep > index + 1 ? index + 1 : payload.currentStep">
                                            <i class="fe fe-check" v-if="payload.currentStep > index + 1"></i><span v-else>0{{ index + 1 }}</span>
                                        </div>
                                        <div class="progress w-100 rounded-0 d-none d-sm-flex" v-if="index < steps.length - 1">
                                            <div class="progress-bar progress-bar-striped bg-secondary" role="progressbar"
                                            :aria-valuenow="20 * (payload.currentStep - 1)" :aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                        </div>
                                        <!-- <p class="text-muted text-center">{{step}}</p>-->
                                    </div>
                                </div>

                                <fieldset v-if="payload.currentStep === 1">
                                    <h5 class="text-muted fw-bold mb-4 text-center text-uppercase" style="font-size: 20px">{{ activeStep }}</h5>
                                    <div class="form-row">
                                        <div class="form-group col-md-6 mb-0">
                                            <ValidationProvider name="idGouvernance" rules="" v-slot="{ errors }">
                                                <label class="form-label">ID Gouvernance <span class="text-danger">*</span></label>
                                                <input type="text" class="form-control" id="idGouvernance" v-model="payload.idGouvernance" placeholder="saisir l'ID de la gouvernance" readonly>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                        <div class="form-group col-md-6 mb-0">
                                            <ValidationProvider name="titre" rules="required" v-slot="{ errors }">
                                                <label class="form-label">Titre de la Gouvernance <span class="text-danger">*</span></label>
                                                <input type="text" class="form-control" id="titre" v-model="payload.titre" 
                                                placeholder="saisir le titre de la gouvernance" :class="{ 'is-invalid': !payload.titre && soumissionTentée }">
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <ValidationProvider name="idTypeGouvernance" rules="required" v-slot="{ errors }">
                                                <label class="form-label">Type de gouvernance <span class="text-danger">*</span></label>
                                                <multi-select v-model="payload.idTypeGouvernance" deselect-label="Sélectionné" select-label="" :options="idTypeGouvernances"
                                                                placeholder="Sélectionné" label="nomTypeGouvernance" track-by="idTypeGouvernance" :searchable="true"
                                                                :custom-label="o => o.nomTypeGouvernance"
                                                                :class="{ 'is-invalid': !payload.idTypeGouvernance && soumissionTentée }">
                                                    <template slot="singleLabel" slot-scope="{ option }">
                                                        <strong> {{ option.nomTypeGouvernance }}</strong>
                                                    </template>
                                                    <span slot="noOptions">
                                                        <strong>Liste Vide</strong>
                                                    </span>
                                                    <span slot="noResult">
                                                        <strong>Aucun Résultat</strong>
                                                    </span>
                                                </multi-select>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <ValidationProvider name="statutGouvernance" rules="required" v-slot="{ errors }">
                                                <label class="form-label">Statut de la gouvernance <span class="text-danger">*</span></label>
                                                <multi-select v-model="payload.statutGouvernance" deselect-label="Sélectionné" select-label="" :options="statuts"
                                                                placeholder="Sélectionné" :searchable="true"
                                                                :class="{ 'is-invalid': !payload.statutGouvernance && soumissionTentée }">
                                                    <template slot="option" slot-scope="{ option }">
                                                        <span>{{ option }}</span>
                                                    </template>
                                                    <template slot="singleLabel" slot-scope="{ option }">
                                                        <span>{{ option }}</span>
                                                    </template>
                                                    <span slot="noOptions">
                                                        <strong>Liste Vide</strong>
                                                    </span>
                                                    <span slot="noResult">
                                                        <strong>Aucun Résultat</strong>
                                                    </span>
                                                </multi-select>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <ValidationProvider name="lienDocumentation" rules="" v-slot="{ errors }">
                                                <label class="form-label">Lien Documentation</label>
                                                <input type="text" class="form-control" id="titre" v-model="payload.lienDocumentation" placeholder="saisir le lien de la documentation">
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <ValidationProvider name="frequenceRencontre" rules="" v-slot="{ errors }">
                                                <label class="form-label">Fréquence de rencontre</label>
                                                <multi-select v-model="payload.frequenceRencontre" deselect-label="Sélectionné" select-label="" :options="frequenceRencontres"
                                                                placeholder="Sélectionné la fréquence de rencontre" :searchable="true">
                                                    <template slot="option" slot-scope="{ option }">
                                                        <span>{{ option }}</span>
                                                    </template>
                                                    <template slot="singleLabel" slot-scope="{ option }">
                                                        <span>{{ option }}</span>
                                                    </template>
                                                    <span slot="noOptions">
                                                        <strong>Liste Vide</strong>
                                                    </span>
                                                    <span slot="noResult">
                                                        <strong>Aucun Résultat</strong>
                                                    </span>
                                                </multi-select>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                      <div class="form-group col-md-12 mb-0">
                                          <ValidationProvider name="commentaires" rules="" v-slot="{ errors }">
                                              <label class="form-label">Commentaire</label>
                                              <textarea name="commentaires" v-model="payload.commentaires" class="form-control" id="commentaires" rows="3"></textarea>
                                              <small class="form-text text-danger">{{ errors[0] }}</small>
                                          </ValidationProvider>
                                      </div>
                                  </div>
                                </fieldset>

                                <fieldset v-if="payload.currentStep === 2">
                                    <h5 class="text-muted fw-bold mb-4 text-center text-uppercase" style="font-size: 20px">{{ activeStep }}</h5>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <ValidationProvider name="president" rules="" v-slot="{ errors }">
                                                <label class="form-label">Président </label>
                                                <multi-select v-model="payload.president" deselect-label="Sélectionné" select-label="" :options="contacts"
                                                                placeholder="Sélectionné" label="contact" track-by="idContact" :searchable="true">
                                                    <span slot="noOptions">
                                                        <strong>Liste Vide</strong>
                                                    </span>
                                                    <span slot="noResult">
                                                        <strong>Aucun Résultat</strong>
                                                    </span>
                                                </multi-select>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <ValidationProvider name="rapporteur" rules="" v-slot="{ errors }">
                                                <label class="form-label">Rapporteur </label>
                                                <multi-select v-model="payload.rapporteur" deselect-label="Sélectionné" select-label=""  :options="contacts"
                                                                placeholder="Sélectionné" label="contact" track-by="idContact" :searchable="true">
                                                    <span slot="noOptions">
                                                        <strong>Liste Vide</strong>
                                                    </span>
                                                    <span slot="noResult">
                                                        <strong>Aucun Résultat</strong>
                                                    </span>
                                                </multi-select>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <ValidationProvider name="pmoReferent" rules="" v-slot="{ errors }">
                                                <label class="form-label">PMO Référent </label>
                                                <multi-select v-model="payload.pmoReferent" deselect-label="Sélectionné" select-label="" :options="contacts"
                                                                placeholder="Sélectionné" label="contact" track-by="idContact" :searchable="true">
                                                    <span slot="noOptions">
                                                        <strong>Liste Vide</strong>
                                                    </span>
                                                    <span slot="noResult">
                                                        <strong>Aucun Résultat</strong>
                                                    </span>
                                                </multi-select>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <ValidationProvider name="pointFocalAsin" rules="" v-slot="{ errors }">
                                                <label class="form-label">Point focal ASIN </label>
                                                <multi-select v-model="payload.pointFocalAsin" deselect-label="Sélectionné" select-label=""  :options="contacts"
                                                                placeholder="Sélectionné" label="contact" track-by="idContact" :searchable="true">
                                                    <span slot="noOptions">
                                                        <strong>Liste Vide</strong>
                                                    </span>
                                                    <span slot="noResult">
                                                        <strong>Aucun Résultat</strong>
                                                    </span>
                                                </multi-select>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <ValidationProvider name="idRoleAsin" rules="required" v-slot="{ errors }">
                                                <label class="form-label">Rôle ASIN <span class="text-danger">*</span></label>
                                                <multi-select v-model="payload.idRoleAsin" deselect-label="Sélectionné" select-label="" :options="rolesAsins"
                                                                placeholder="Sélectionné" label="nomRole" track-by="idRole" 
                                                                :class="{ 'is-invalid': !payload.idRoleAsin && soumissionTentée }" :searchable="true">
                                                    <span slot="noOptions">
                                                        <strong>Liste Vide</strong>
                                                    </span>
                                                    <span slot="noResult">
                                                        <strong>Aucun Résultat</strong>
                                                    </span>
                                                </multi-select>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <ValidationProvider name="idPoleAsin" rules="required" v-slot="{ errors }">
                                                <label class="form-label">Pole ASIN <span class="text-danger">*</span></label>
                                                <multi-select v-model="payload.idPoleAsin" deselect-label="Sélectionné" select-label="" :options="polesAsins"
                                                                placeholder="Sélectionné" label="nomPole" track-by="idPole" 
                                                                :class="{ 'is-invalid': !payload.idPoleAsin && soumissionTentée }" :searchable="true">
                                                    <span slot="noOptions">
                                                        <strong>Liste Vide</strong>
                                                    </span>
                                                    <span slot="noResult">
                                                        <strong>Aucun Résultat</strong>
                                                    </span>
                                                </multi-select>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                </fieldset>

                                <fieldset v-if="payload.currentStep === 3">
                                    <h5 class="text-muted fw-bold mb-4 text-center text-uppercase" style="font-size: 20px">{{ activeStep }}</h5>
                                    <div class="form-row">
                                    </div>
                                </fieldset>

                                <fieldset v-if="payload.currentStep === 4">
                                    <h5 class="text-muted fw-bold mb-4 text-center text-uppercase" style="font-size: 20px">{{ activeStep }}</h5>
                                    <div class="table-responsive">
                                        <div v-for="(stepFields, index) in groupedFields" :key="index" class="mb-4">
                                            <table class="table table-hover table-bordered">
                                                <thead>
                                                    <tr class="success02 text-center">
                                                        <th colspan="2" class="fw-bold">Étape {{ index + 1 }}</th>
                                                    </tr>
                                                    <tr class="info02">
                                                        <th class="fw-bold">Champ</th>
                                                        <th class="fw-bold">Valeur</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="field in stepFields" :key="field.key" :class="{'table-danger': isEmpty(field.value)}">
                                                        <td class="fw-bold">{{ field.label }}</td>
                                                        <td>
                                                            <span v-if="typeof field.value == 'object' && field.value != null">
                                                            {{ field.value.libelle || field.value.nomTypeGouvernance || field.value.nomRole || field.value.nomPole || field.value.contact || '[Objet]' }}
                                                            </span>
                                                            <span v-else>
                                                            {{ field.value || '[Non renseigné]' }}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </fieldset>

                                <div class="alert alert-success mt-3" v-if="true">
                                    <small>
                                        Etape : {{ payload.currentStep }} / {{ steps.length }} | 
                                        Dernière : {{ isLastStep ? 'OUI' : 'NON' }} | 
                                        Actif : {{ activeStep }}
                                    </small>
                                </div>
                                <div class="form-group d-flex justify-content-between mt-5">
                                    <button type="button" class="style_btn btn btn-outline-dark rounded-0" @click.prevent="sentBack" id="previous">
                                        {{ payload.currentStep === 1 ? 'Fermer' : 'Précédent' }}
                                    </button>
                                    <button type="submit" class="style_btn float-right btn btn-outline-success rounded-0" id="next">
                                        {{ isLastStep ? save ? 'Enregistrer' : 'Modifier' : 'Suivant' }}
                                    </button>
                                </div>
                              </form>
                          </ValidationObserver>
                      </div>
                  </div>
              </div>
           </div>
      </div>
    </div>
  </template>
  
  <script>
  import { mapGetters, mapActions } from 'vuex';
  import { reduce } from "lodash";
  import * as lang from "vuejs-datepicker/src/locale";
  export default {
      name: "Gouvernance",
      data() {
          return {
              lang: lang, loading: false, showList: true,
              payload: {currentStep: 1, idGouvernance: '', idTypeGouvernance: {}, president: {idContact: 'A confirmer', contact: 'A confirmer'}, rapporteur: {idContact: 'A confirmer', contact: 'A confirmer'},
                pmoReferent: {idContact: 'A confirmer', contact: 'A confirmer'}, pointFocalAsin: {idContact: 'A confirmer', contact: 'A confirmer'}, idRoleAsin: {idRole: 'A confirmer', nomRole: 'A confirmer'},
                idPoleAsin: {idPole: 'A confirmer', nomPole: 'A confirmer'}, titre: '', statutGouvernance: 'Actif', lienDocumentation: '', commentaires: '', frequenceRencontre: 'MENSUELLE'}, save: true,
              steps: [
                'Gouvernance | Informations générales', 'Membres de la gouvernance', 'Pièces jointes', 'Récapitulatif'
                ], soumissionTentée: false,
                statuts: ['ACTIF', 'INACTIF'],
                rolesAsins: [], polesAsins: [], idTypeGouvernances: [], contacts: [],
                frequenceRencontres: ['MENSUELLE', 'TRIMESTRIELLE', 'SEMESTRIELLE', 'ANUELLE'],
          }
      },
      computed: {
        ...mapGetters({ items: 'gouvernance/list' }),
        fr() {
            return this.lang.fr;
        },
        filterItems() {
            return this.items?.content || [];
        },
        activeStep() {
            return this.steps[this.payload.currentStep - 1] || `Étape ${this.payload.currentStep}`;
        },
        isLastStep() {
            return this.payload.currentStep >= this.steps.length;
        },
        groupedFields() {
            return [
                // Étape 1
                [
                    { key: 'idGouvernance', label: 'ID Gouvernance', value: this.payload.idGouvernance },
                    { key: 'titre', label: 'Titre', value: this.payload.titre },
                    { key: 'idTypeGouvernance', label: 'Type Gouvernance', value: this.payload.idTypeGouvernance },
                    { key: 'statutGouvernance', label: 'Statut', value: this.payload.statutGouvernance },
                    { key: 'frequenceRencontre', label: 'Fréquence Rencontre', value: this.payload.frequenceRencontre },
                    { key: 'lienDocumentation', label: 'Lien Documentation', value: this.payload.lienDocumentation },
                    { key: 'commentaires', label: 'Commentaire', value: this.payload.commentaires },
                ],
                // Étape 2
                [
                    { key: 'president', label: 'Président', value: this.payload.president },
                    { key: 'rapporteur', label: 'Rapporteur', value: this.payload.rapporteur },
                    { key: 'pmoReferent', label: 'PMO Référent', value: this.payload.pmoReferent },
                    { key: 'pointFocalAsin', label: 'Point Focal ASIN', value: this.payload.pointFocalAsin },
                    { key: 'idRoleAsin', label: 'Role ASIN', value: this.payload.roleAsin },
                    { key: 'idPoleAsin', label: 'Pole ASIN', value: this.payload.poleAsin },
                ],
                // Étape 3
                [
                    
                ],
            ];
        },
      },
      methods:{
            ...mapActions('gouvernance', ['all', 'add']),
            initPayload() {
                this.payload = {currentStep: 1, idGouvernance: '', idTypeGouvernance: {idTypeGouvernance: '', nomTypeGouvernance: ''}, president: {idContact: 'A confirmer', contact: 'A confirmer'}, rapporteur: {idContact: 'A confirmer', contact: 'A confirmer'},
                pmoReferent: {idContact: 'A confirmer', contact: 'A confirmer'}, pointFocalAsin: {idContact: 'A confirmer', contact: 'A confirmer'}, idRoleAsin: {idRole: 'A confirmer', nomRole: 'A confirmer'},
                idPoleAsin: {idPole: 'A confirmer', nomPole: 'A confirmer'}, titre: '', statutGouvernance: 'Actif', lienDocumentation: '', commentaires: '', frequenceRencontre: 'MENSUELLE'};
            },
        champsObligatoiresValides() {
            const p = this.payload;

            const champsInvalides = [
            !p.titre,
            !p.statutGouvernance,
            !p.idTypeGouvernance,
            ];

            return !champsInvalides.includes(true);
        },
        isEmpty(value) {
            return value === null || value === '' || (typeof value === 'object' && Object.keys(value).length === 0);
        },
          showForm() {
              this.showList = false;
              this.save = true;
          },
          sentBack() {
              if (this.payload.currentStep === 1) {
                this.showList = true;
                this.initPayload();
            } else {
                this.payload.currentStep--;
            }
          },
          showTypesGouvernance(){
              this.$router.push({ name: 'typeGouvernance' });
          },
        updateActiveStepTitle() {
            this.activeStep = this.steps[this.payload.currentStep - 1] || `Étape ${this.payload.currentStep}`;
        },
        onNextep() {
            if (this.payload.currentStep === 1) {
                if (!this.payload.idTypeGouvernance) {
                    return swal('Information!', 'Le type de gouvernance est requis.', 'error');
                }else if(!this.payload.titre || this.payload.titre.trim() === '') {
                    return swal('Information!', 'Le titre est requis.', 'error');
                }
                this.payload.currentStep++;
                this.updateActiveStepTitle();
            } else {
                if (this.isLastStep){
                    return this.submit();
                }else{
                    this.payload.currentStep++;
                    this.updateActiveStepTitle();
                }
            }
            console.log('Nouvelle étape : ', this.payload.currentStep);
        },
          onSearch(offset) {
              this.$loading(true);
              if (offset > 0) this.option.page = offset - 1;
              this.$router.push({ query: this.option }).catch(() => { });
              this.$store.dispatch('gouvernance/all', this.option).finally(() => this.$loading(false));
          },
          submit(){
            const self = this;
            self.$loading(true);
            if (!self.champsObligatoiresValides()) {
                self.soumissionTentée = true;
                console.log('Veuillez remplir les champs obligatoires.');
                swal('Information!', 'Veuillez remplir les champs obligatoires avant d\'enregistrer. Vérifiez les champs en rouge ou les champs avec astérisque (*).', 'warning');
                return self.$loading(false);
            }
            self.$loading(false);
              if(self.save){
                  console.log(self.payload);
                  swal({
                    title: "Confirmation",
                    text: "Etes-vous sûr de vouloir enregistrer la gouvernance ?",
                    type: "warning",
                    showCancelButton: true,
                    closeOnConfirm: false,
                    cancelButtonText: "Annuler",
                    confirmButtonText: "Enregistrer",
                    confirmButtonColor: "#7db0b2",
                    cancelButtonColor: "#FF0000",
                    showLoaderOnConfirm: true
                }, function(result) {
                    if (result === true) {
                        self.$loading(true);
                        self.$http.post('/gouvernance', self.payload)
                        .then(({data}) => {
                            if(data){
                                swal('Information!', 'Gouvernance enregistrée avec succès.', 'success');
                                self.onSearch();
                                self.initPayload();
                            }else{
                                swal('Information!', 'L\'enregistrement de la gouvernance n\a pas pu être effectué.', 'warning');
                            }
                        })
                        .catch((error) => {
                            swal('Information!', 'Une erreur est survenue lors de l\'enregistrement. ' + error, 'warning');
                        })
                        .finally(() => self.$loading(false));
                    }
                });
              }else{
                  console.log("Editer", self.payload);
                  swal({
                    title: "Confirmation",
                    text: "Etes-vous sûr de vouloir modifier la gouvernance ?",
                    type: "warning",
                    showCancelButton: true,
                    closeOnConfirm: false,
                    cancelButtonText: "Annuler",
                    confirmButtonText: "Modifier",
                    confirmButtonColor: "#7db0b2",
                    cancelButtonColor: "#FF0000",
                    showLoaderOnConfirm: true
                    }, function(result) {
                        if (result === true) {
                            self.$loading(true);
                            self.$http.put('/gouvernance/' + self.payload.id, self.payload)
                            .then(({data}) => {
                                if(data){
                                    swal('Information!', 'Gouvernance modifiée avec succès.', 'success');
                                    self.onSearch();
                                    self.initPayload();
                                }else{
                                    swal('Information!', 'La modification de la gouvernance n\'a pas pu être effectuée.', '.', 'warning');
                                }
                            })
                            .catch((error) => {
                                swal('Information!', 'Une erreur est survenue lors de la modification. ' + error, 'warning');
                            })
                            .finally(() => self.$loading(false));
                        }
                    });
              }
          },
          edit(value){
            this.$loading(true);
            this.save = false;
            this.payload = {...value};
            this.showForm();
            this.$loading(false);
          },
          drop(item){
            const self = this;
            swal({
                title: "Confirmation",
                text: "Etes-vous sûr de vouloir supprimer la gouvernance ?",
                type: "warning",
                showCancelButton: true,
                closeOnConfirm: false,
                cancelButtonText: "Annuler",
                confirmButtonText: "Supprimer",
                confirmButtonColor: "#7db0b2",
                cancelButtonColor: "#FF0000",
                showLoaderOnConfirm: true
            }, function(result) {
                if (result === true) {
                    self.$loading(true);
                    self.$http.delete('/gouvernance/' + item.id)
                    .then(({data}) => {
                            swal('Information!', 'Gouvernance supprimée avec succès.', 'success');
                            self.onSearch();
                            self.showList = true;
                    })
                    .catch((error) => {
                        swal('Information!', 'Une erreur est survenue lors de la suppression. ' + error, 'warning');
                    })
                    .finally(() => self.$loading(false));
                }
            });
        },
      },
      created() {
            this.onSearch();
            this.$http.get('/typeGouvernance/all')
            .then(({data}) =>{
                this.idTypeGouvernances = data;
            });
            this.$http.get('/roleAsin')
            .then(({data}) =>{
                this.rolesAsins = data;
            });
            this.$http.get('/poleAsin')
            .then(({data}) =>{
                this.polesAsins = data;
            });
            this.$http.get('/contacts')
            .then(({data}) =>{
                this.contacts = data;
            });
      }
  }
  </script>
  
  <style>
    th {
    cursor: pointer;
    }
    select.is-invalid {
    border: 1px solid #dc3545 !important;
    background-color: #fef2f2;
    }
  </style>